var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98413 4C8.69879 4 9.35479 4.176 9.95213 4.528C10.5601 4.88 11.0401 5.36 11.3921 5.968C11.7441 6.56533 11.9201 7.22133 11.9201 7.936V10.032H14.6401V18.976C14.6188 19.2853 14.5175 19.5307 14.3361 19.712C14.1335 19.904 13.8881 20 13.6001 20H2.36812C2.06946 20 1.81879 19.8987 1.61612 19.696C1.42412 19.504 1.32812 19.264 1.32812 18.976V10.032H4.04813V7.936C4.04813 7.22133 4.22413 6.56533 4.57613 5.968C4.92813 5.36 5.40279 4.88 6.00013 4.528C6.60813 4.176 7.26946 4 7.98413 4ZM13.6001 11.056H2.36812V18.976H13.6001V11.056ZM8.64013 13.328V16.816H7.32813V13.328H8.64013ZM7.98413 5.264C7.49346 5.264 7.04013 5.38667 6.62413 5.632C6.20813 5.86667 5.87213 6.18667 5.61613 6.592C5.37079 6.99733 5.23746 7.44533 5.21612 7.936V10.032H10.7521V7.936C10.7415 7.44533 10.6081 6.99733 10.3521 6.592C10.0961 6.18667 9.76013 5.86667 9.34413 5.632C8.92813 5.38667 8.47479 5.264 7.98413 5.264Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.af91b3b333ed83d5365451f52922ce70.svg";
export { ForwardRef as ReactComponent };